export function NetworkError() {
  this.type = 'NETWORK_ERROR';
  this.title = 'Ha ocurrido un error de conexión al servidor';
  this.detail = 'Ha ocurrido un error de conexión al servidor';
  this.toString = () => {
    return this.detail;
  };
}
